import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRightLeft, Calendar, User } from "lucide-react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { getInventoryTransfers } from "@/integrations/supabase/inventory-services";
import { useAuth } from "@/context/AuthContext";

const InventoryTransfersView = () => {
  const { profile } = useAuth();
  const branchId = profile?.role === 'operator' ? profile.branch_id : undefined;

  const { data: transfers, isLoading } = useQuery({
    queryKey: ['inventory-transfers', branchId],
    queryFn: () => getInventoryTransfers(branchId),
  });

  if (isLoading) {
    return <div className="text-center py-4">Cargando transferencias...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">
          {profile?.role === 'super_admin' ? 'Todas las Transferencias' : 'Transferencias Recibidas'}
        </h3>
      </div>

      <div className="grid gap-4">
        {transfers?.map((transfer) => (
          <Card key={transfer.id}>
            <CardHeader className="pb-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <ArrowRightLeft className="h-5 w-5 text-bike-600" />
                  <div>
                    <CardTitle className="text-lg">{transfer.spare_part_type?.name}</CardTitle>
                    <div className="flex items-center gap-2 mt-1">
                      <Badge variant="secondary">
                        Inventario Principal → {transfer.branch?.name}
                      </Badge>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-bike-600">{transfer.quantity}</div>
                  <div className="text-sm text-gray-500">unidades</div>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-gray-500" />
                  <span>
                    {format(new Date(transfer.transfer_date), 'PPP p', { locale: es })}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <User className="h-4 w-4 text-gray-500" />
                  <span>{transfer.transferred_by_profile?.full_name || 'Usuario'}</span>
                </div>
              </div>
              {transfer.notes && (
                <div className="mt-3 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-700">
                    <strong>Notas:</strong> {transfer.notes}
                  </p>
                </div>
              )}
            </CardContent>
          </Card>
        ))}

        {transfers?.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No hay transferencias registradas
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryTransfersView;
